import { queryOptions } from "@tanstack/react-query";
import { z } from "zod";
import { api } from "./apiClient";
import { FORMS_API_BASE_ENDPOINT } from "./constants";

const BASE_ENDPOINT = `${FORMS_API_BASE_ENDPOINT}/admin/scimadgroup`;

const scimAdGroupsKeys = {
  all: () => ["scimAdGroups"] as const,
} as const;

const ScimAdGroupSchema = z.object({
  id: z.string(),
  organisationId: z.string(),
  externalId: z.string(),
  name: z.string(),
});

export type ScimAdGroup = z.infer<typeof ScimAdGroupSchema>;

export const scimAdGroupsQueryOptions = () =>
  queryOptions({
    queryKey: scimAdGroupsKeys.all(),
    queryFn: () => api.get(BASE_ENDPOINT, { schema: z.array(ScimAdGroupSchema) }),
    throwOnError: true,
  });
